import _ from 'lodash';
import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

// Material UI
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl/FormControl';

// Components
import { dangerColor } from '../../../lib/theme';
import { FormikFieldLabel } from './formik-field-label.component';
import { FormikFieldCommonProps, useFormikField } from './use-formik-field';

interface IFormikSelect extends FormikFieldCommonProps {
  canCreate?: boolean;
  createMethod?: Function;
  options: any[];
  margin?: 'none' | 'dense' | 'normal';
  isMulti?: boolean;
  disabled?: boolean
}

export const FormikSelect: React.FC<IFormikSelect> = ({ margin, canCreate, createMethod, options, field, form, fid, id, label, isMulti, disabled, ...rest }) => {
  const Control: any = canCreate ? CreatableSelect : Select;
  const { id: _id, error, touched } = useFormikField({ field, form, fid, id });
  const showError = !!touched && _.isString(error);
  const errorStyles = {
    control: (base: any) => ({ ...base, borderColor: dangerColor, '&:hover': { borderColor: dangerColor } }),
  };

  options = options.length && _.isString(options[0])
    ? _.map(options, option => ({ value: option, label: option }))
    : options;

  return (
    <FormControl margin={margin || 'dense'} fullWidth component="div" error={!!error && touched}>
      <FormikFieldLabel label={label} htmlFor={_id} hasError={showError} />
      <Control
        id={_id}
        styles={showError ? errorStyles : undefined}
        {...rest}
        options={options}
        name={field.name}
        noOptionsMessage={() => canCreate ? 'Type to create new' : 'No Options'}
        value={field.value}
        onChange={(option: any, context: any) => {
          if (canCreate && context.action === 'create-option') {
            if (!createMethod) {
              form.setFieldValue(`create${_.upperFirst(field.name)}`, true)
            } else {
              createMethod(form, context.option.value, field.name);
            }
          }

          if (!canCreate || !createMethod || context.action !== 'create-option') {
            form.setFieldValue(field.name, option)
          }
        }}
        onBlur={field.onBlur}
        isMulti={isMulti}
        isDisabled={disabled}
      />
      {showError && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};
